import { render, staticRenderFns } from "./BadgeStatus.vue?vue&type=template&id=d08bebe6"
import script from "./BadgeStatus.vue?vue&type=script&lang=js"
export * from "./BadgeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports